import {
  Component,
  OnInit,
  Input,
  Inject,
  HostListener,
  Output,
  EventEmitter,
  forwardRef
} from "@angular/core";
import { Router } from "@angular/router";
import { DOCUMENT } from "@angular/common";

//Models
import { UserCourse } from "app/core/models/user-course";
import { CurriculumReview } from "app/core/models/curriculum-review";
import { AssessmentFormat } from "app/core/models/assessment-format";
import { TlaFormat } from "app/core/models/tla-format";
import { CourseOutcome } from "app/core/models/course-outcome";
import { ProgramOutcome } from "app/core/models/program-outcome";
import { ProgramOutcomeCategory } from "app/core/models/program-outcome-category";
import { Dialog } from "app/core/models/dialog";
import { UserStep } from "app/core/models/user-step";
import { CustomError } from "app/core/models/custom-error";
import { Level } from "app/core/models/level";
import { Question } from "app/core/models/question";
import { CourseOutcomeSelectedAssessmentMethod } from "app/core/models/course-outcome-selected-assessment-method";
import { CourseOutcomeSelectedTlaOption } from "app/core/models/course-outcome-selected-tla-option";
import { AnalysisQuestion } from "app/core/models/analysis-question";

//Services
import { AlertService } from "app/core/services/alert.service";
import { CourseOutcomeService } from "app/core/services/course-outcome.service";
import { DimmerService } from "app/core/services/dimmer.service";
import { AssessmentService } from "app/core/services/assessment.service";
import { QuestionService } from "app/core/services/question.service";
import { MappingService } from "app/core/services/mapping.service";
import { CourseService } from "app/core/services/course.service";

//Libraries
import { finalize } from "rxjs/operators";

import * as html2canvas from "html2canvas";
// import * as pdfMake from "pdfmake/build/pdfmake";
// import * as pdfFonts from "pdfmake/build/vfs_fonts";
import * as jsPDF from "html2canvas";

@Component({
  selector: "app-user-step-summary",
  templateUrl: "./user-step-summary.component.html",
  styleUrls: ["./user-step-summary.component.scss"]
})
export class UserStepSummaryComponent implements OnInit {
  @Input()
  courseId: number;
  @Input()
  review: CurriculumReview;
  @Input()
  assessmentFormat: AssessmentFormat;
  @Input()
  tlaFormat: TlaFormat;
  @Input()
  programOutcomes: Array<ProgramOutcome>;
  @Input()
  programOutcomeCategories: Array<ProgramOutcomeCategory>;
  @Input()
  userCourse: UserCourse;

  @Input()
  userSteps: Array<UserStep>;

  @Output()
  prevStep: EventEmitter<string> = new EventEmitter();

  @Output()
  courseSubmitted: EventEmitter<any> = new EventEmitter();

  relatingTo: string = "course";

  //data
  courseOutcomes: Array<CourseOutcome> = [];
  levels: Array<Level> = [];
  dialog: Dialog;

  //flags
  courseOutcomesLoading: boolean = true;
  dialogUpdating: boolean = false;
  shouldShowThankYouForm: boolean = false;
  shouldShowFullScreen: boolean = false;
  shouldShowPdfScreen: boolean = false;
  pdfGenerating: boolean = true;
  pdfSuccess: boolean = false;

  pdfUrl: string;
  pdfBlob: Blob;

  // @Input()
  // assessmentFormat: AssessmentFormat;

  // @Input()
  // tlaFormat: TlaFormat;

  // @Input()
  // courseId: number;

  // @Input()
  // levels: Array<Level>;

  // @Input()
  // courseStatus: string;

  // @Input()
  // completedSteps: any;

  // @Input()
  // unsavedSteps: any;

  // // selectedAssessmentMethods: Array<AssessmentMethodValue> = [];
  // selectedAssessmentTotalWeight: number = 0;

  // @Input()
  // programOutcomes: Array<ProgramOutcome>

  // @Input()
  // programOutcomeCategories: Array<ProgramOutcomeCategory> = [];

  // selectedCourseTlaValues: Array<TlaOptionValue> = [];

  // courseOutcomes: Array<CourseOutcomeValue>;

  // courseQuestions: Array<Question>;

  // @Output()
  // activate: EventEmitter<any> = new EventEmitter();

  // @Output()
  // stepLoaded: EventEmitter<any> = new EventEmitter();

  // @Output()
  // stepCompleted: EventEmitter<boolean> = new EventEmitter();

  // mappedValue: Array<any> = [];

  // courseAssessments: Array<any> = [];
  // courseOutcomeAssessments: Array<any> = []; //courseOutcomeAssessmentMethods[courseOutcomeId] = assessmentObject
  // totalWeight: number = 0;

  // courseTlas: Array<any> = []; //tlas selected by the course
  // courseOutcomeTlas: Array<any> = []; //tlas selected by course outcome: courseOutcomeTlas[courseOutcomeId] = tlaObject

  outcomeQuestions: Array<Question> = [];
  courseQuestions: Array<Question> = [];

  courseAnalysisQuestions: Array<AnalysisQuestion> = [];

  // showScrollButton: boolean = false;

  // visibleSections: { 'assessment': boolean, 'mapping': boolean, 'tla': boolean, 'outcome': boolean, 'question': boolean };
  // loadedSections: { 'assessment': boolean, 'tla': boolean, 'outcome': boolean, 'question': boolean, 'mapping': boolean };

  // error: { "show": boolean, "message": string };

  loading: { isLoading: boolean; text: string };

  //errors
  loadError: CustomError;
  actionErrors: Array<CustomError> = [];

  // //show saving status
  // savingStatus: { 'show': boolean, 'title': string, 'text': string, 'status': string };

  constructor(
    // @Inject(forwardRef(() => UserCourseComponent))
    // private _parent: UserCourseComponent,
    // private programOutcomeService: ProgramOutcomeService,
    private courseOutcomeService: CourseOutcomeService,
    private mappingService: MappingService,
    private dimmerService: DimmerService,
    // private userService: UserService,
    // private tlaService: TlaService,
    // private questionService: QuestionService,
    // private assessmentService: AssessmentService,
    // @Inject(DOCUMENT) private document: Document,
    // private dimmerService: DimmerService,
    private courseService: CourseService,
    private alertService: AlertService,
    private questionService: QuestionService,
    // private assessmentService: AssessmentService,
    // private navBarService: NavBarService,
    private router: Router
  ) {}

  async ngOnInit() {

    // console.log(this.review);

    this.loading = { isLoading: false, text: "Loading course summary..." };

    try {
      //load existing outcomes
      this.courseOutcomes = await this.courseOutcomeService.getCourseOutcomes(
        this.courseId
      );

      //load levels
      let levels = await this.mappingService.getScaleLevelsForCourse(
        this.courseId
      );

      levels.forEach(level => {
        this.levels.push(
          new Level(
            level.id,
            level.name,
            level.description,
            level.abbreviation,
            level.colorCode,
            level.level,
            level.bgColor,
            level.fontColor
          )
        );
      });

      //get questions for course outcome
      this.outcomeQuestions = await this.questionService.getQuestionsByCourseId(
        this.courseId,
        "outcome"
      );

      // console.log(this.outcomeQuestions);

      this.courseQuestions = await this.questionService.getQuestionsByCourseId(
        this.courseId,
        this.relatingTo
      );

        this.courseAnalysisQuestions = await this.mappingService.getAnalysisQuestions(this.review.id);

        // console.log(this.courseAnalysisQuestions);

    } catch (error) {

      this.loadError = error;
    } finally {
    }
  }

  //for submit dialog

  submitCourse() {
    //clear action errors
    this.actionErrors = [];

    //show confirm dialog
    this.dimmerService.dimWindow(true);
    this.dialog = new Dialog(
      true,
      "Please confirm",
      "Are you sure you want to submit this course information for curriculum review? You will not be able to modify your course information after it's submitted.",
      "No, don't submit",
      "Yes, submit the course information",
      "Processing..",
      "submit"
    );
  }

  /**
   * Cancel delete - close saving status
   */
  closeDialog() {
    this.clearAll();
  }

  async proceedSubmit() {
    this.dialogUpdating = true;

    try {
      await this.courseService.submitCourse(this.courseId);

      this.courseSubmitted.emit();

      this.shouldShowThankYouForm = true;
    } catch (error) {
      console.log(error);

      this.actionErrors.push(error);
      this.dimmerService.dimWindow(false);
    } finally {
      if (this.dialog) this.dialog.show = false;
      this.dialogUpdating = false;
    }

    // if (this.dialog) this.dialog.show = false;

    // this.shouldShowThankYouForm = true;

    // if (this.actionErrors.length > 0) {
    //   this.handleActionErrors();
    // }

    // .pipe(
    //   finalize(() => {
    //     //set this course status to submitted.
    //     this.courseSubmitted.emit();

    //     if (this.dialog) this.dialog.show = false;

    //     this.shouldShowThankYouForm = true;

    //     if (this.actionErrors.length > 0) {
    //       this.handleActionErrors();
    //     }
    //   })
    // )
    // .subscribe(() => {}, error => {});
  }

  previousStepClicked() {
    this.prevStep.emit();
  }

  clearAll() {
    if (this.dialog) this.dialog.show = false;
    this.shouldShowThankYouForm = false;
    this.dimmerService.dimWindow(false);
  }

  handleActionErrors() {
    this.alertService.showAlert(
      false,
      "Error while updating the database.",
      false,
      this.actionErrors
    );
  }

  openFullScreen() {
    this.dimmerService.dimWindow(true);
    this.shouldShowFullScreen = true;
  }

  closeFullScreen() {
    this.dimmerService.dimWindow(false);
    this.shouldShowFullScreen = false;
  }

  async generatePdf() {
    // console.log(this.userCourse);

    this.shouldShowPdfScreen = true;
    this.dimmerService.dimWindow(true);
    this.pdfGenerating = true;

    this.courseService.downloadCourseSummary(this.courseId).then(
      data => {
        // console.log(data);

        let binary = atob(data.pdf);

        const length = binary.length;
        let buffer = new ArrayBuffer(length);
        let array = new Uint8Array(buffer);

        for (var i = 0; i < length; i++) {
          array[i] = binary.charCodeAt(i);
        }
        this.pdfBlob = new Blob([array], { type: "application/pdf" });

        //show download link
        this.pdfGenerating = false;
        this.pdfSuccess = true;
      },
      error => {
        console.log(error);

        this.pdfGenerating = false;
        this.pdfSuccess = false;
      }
    );
  }

  downloadPdf() {
    const data = window.URL.createObjectURL(this.pdfBlob);

    let fileName =
      this.userCourse.code + "_" + this.userCourse.number + "_summary.pdf";

    let link = document.createElement("a");
    link.href = data;
    link.download = fileName;
    // link.click();

    link.dispatchEvent(
      new MouseEvent("click", { bubbles: false, cancelable: false })
    );

    //firefox not working??

    setTimeout(() => {
      window.URL.revokeObjectURL(data);
    }, 100);

    this.shouldShowPdfScreen = false;
    this.dimmerService.dimWindow(false);
    this.pdfGenerating = false;
  }

  cancelDownload() {
    this.pdfBlob = null;

    this.shouldShowPdfScreen = false;
    this.dimmerService.dimWindow(false);
    this.pdfGenerating = false;
  }
}
